import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    notification$: BehaviorSubject<{
        type: string, data: any, className?: string
    }> = new BehaviorSubject(null);

    constructor() {
    }

    notify(type: string, data = {}, className?: string) {
        this.notification$.next({
            type, data, className
        });
        setTimeout(() => {
            this.notification$.next(null);
        }, 4000);
    }
}
